import styled from 'styled-components';
import { fontSize, fontWeight, formLabel } from 'modules/theme';
import { marginRight, unit } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const PhoneInputContainer = styled.div `
  display: ${(props) => (props.$stretch ? 'flex' : 'inline-flex')};
  flex-direction: column;
`;
export const PhoneInputLabel = styled.label `
  ${formLabel};
`;
export const PhoneInputDescription = styled.div `
  ${fontSize('small')};
  ${fontWeight('normal')};
  color: ${themeGet('colors.gray.700')};
`;
export const Container = styled.div `
  display: flex;
`;
export const SelectContainer = styled.div `
  ${marginRight(2)};
  flex: 0 0 20%;
  min-width: ${unit(25)};
`;
export const InputContainer = styled.div `
  flex: 1 1 80%;
`;
